/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-14 15:31:50
 *
 *******************************************************/
//@flow

import React from 'react';
import Classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

export const Switch = ({
  id,
  disabled,
  label,
  icon,
  value,
  tooltip,
  onChange,
  size = 'large',
  tooltipOptions = {
    placeTooltip: 'bottom',
    effectTooltip: 'solid',
    overridePosition: ({ left, top }) => ({ left, top })
  }
}) => {
  const handleToggle = e => {
    onChange(e.target.checked);
  };

  return (
    <div className="BC-Toggle-Switch-Button">
      <label
        className={Classnames('BC-Switch-Status', {
          'BC-Switch-Status--small': size === 'small'
        })}
        data-for={id}
        data-tip={tooltip}>
        <input
          id={id}
          type="checkbox"
          disabled={disabled}
          checked={value ? true : false}
          onChange={handleToggle}
        />
        <div className="BC-Switch-Status__Bar" style={{ cursor: disabled ? 'default' : 'pointer' }}>
          <div className="BC-Switch-Status__Dot">{icon}</div>
        </div>
      </label>

      {/* Render label */}
      {label && (
        <div style={{ width: 'fit-content', marginLeft: '8px' }}>
          <div className="Polaris-Labelled__LabelWrapper">
            <div className="Polaris-Label">
              <label
                style={{ display: 'inline', color: disabled ? '#8C9196' : '' }}
                className={`Polaris-Label__Text ${disabled ? 'disabled' : ''}`}>
                {label}
              </label>
            </div>
          </div>
        </div>
      )}

      <ReactTooltip
        id={id}
        place={tooltipOptions?.placeTooltip}
        effect={tooltipOptions?.effectTooltip}
        overridePosition={tooltipOptions?.overridePosition}
        type="light"
      />
    </div>
  );
};
